module.exports = __webpack_public_path__ + "img/filter.345ccecd.svg";